export class GcpNetworkConnectivityConfig {
    'network';
    'subnetsPerRegion';
    'isSharedVpc';
    'networkHostProject';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "network",
            "baseName": "network",
            "type": "string",
            "format": ""
        },
        {
            "name": "subnetsPerRegion",
            "baseName": "subnetsPerRegion",
            "type": "Array<GcpSubnetPerRegion>",
            "format": ""
        },
        {
            "name": "isSharedVpc",
            "baseName": "isSharedVpc",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "networkHostProject",
            "baseName": "networkHostProject",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GcpNetworkConnectivityConfig.attributeTypeMap;
    }
    constructor() {
    }
}
